var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import fetch from '../fetch/fetch';
import { METHOD } from '../fetch/types';
export const login = (identifier, password) => __awaiter(void 0, void 0, void 0, function* () {
    const { status, token } = yield fetch(METHOD.POST, '/auth/login', {
        identifier,
        password,
    });
    if (status && token) {
        return token;
    }
    return false;
});
export const resolveToken = (token) => __awaiter(void 0, void 0, void 0, function* () {
    const { status, accountLink } = yield fetch(METHOD.POST, '/auth/resolve-token', {
        token,
    });
    return status ? accountLink : false;
});
